(function ($) {
  "use strict";

  Drupal.behaviors.imageSlick = {
    attach: function (context, settings) {
      $(".view-episodes .view-content", context).slick({
        infinite: false,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              arrows: false,
              slidesToShow: 1,
            },
          },
        ],
      });

      // Highlighted scenes on serie.
      $(".view-highlighted-scenes .view-content", context).slick({
        infinite: true,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: null,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      $(".view-serie-carousel .view-content", context).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        prevArrow: null,
        nextArrow: null,
        autoplay: true,
        autoplaySpeed: 5000,
      });

      // Highlighted series block.
      $(".view-highlighted-series-highlighted .view-content", context).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:
          "<button class='slick-prev slick-arrow' aria-label='Vorige' type='button'></button>",
        nextArrow:
          "<button class='slick-next slick-arrow' aria-label='Volgende' type='button'></button>",
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    },
  };

  Drupal.behaviors.modal = {
    attach: function (context, settings) {
      function playerBlinder(playerblinder){
        if (!playerblinder){
          return;
        }
        const $overlay = playerblinder.clone(true);
        $overlay.appendTo("body").addClass("visible");
        $overlay.find('iframe').attr('src', $overlay.find('iframe').attr('src') + '&autoplay=1');
        $("body").addClass("modal-visible"); 
      }
      
      $(".js-hero-play--trailer").once().click(function () {
        playerBlinder($(this).closest(".hero--video").find(".hero--teaser .player-blinder"));
      });
      $(".js-hero-play--episode").once().click(function () {
        playerBlinder($(this).closest(".hero--video").find(".field--name-field-episodes .player-blinder"));
        playerBlinder($(this).closest(".hero--video").find(".node--type-episode.node--view-mode-frontpage .player-blinder"));
      });

      $(".js-hero-play--newest").once().click(function () {
        playerBlinder($(".field--name-field-episodes .player-blinder").first());
      });

      $(".node--view-mode-frontpage .openModal").once().click(function () {
        playerBlinder($(".node--view-mode-frontpage .player-blinder"));
      });

      $(".js-play-series").once().click(function (e) {
        e.preventDefault();
        playerBlinder($(this).closest(".node--type-episode").find(".player-blinder"));
      });



      $(".js-close-modal").once().click(function (e) {
        e.preventDefault();
        $(".player-blinder.visible").remove();
        $("body").removeClass("modal-visible");
      });
    },
  };

  Drupal.behaviors.scrollDetector = {
    attach: function (context, settings) {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 0) {
          $("body").addClass("offset");
        } else {
          $("body").removeClass("offset");
        }
      });
    },
  };

  Drupal.behaviors.responsiveMenu = {
    attach: function (context, settings) {
      // de code voor het responsive menu hier.
      // $('class', context). [let op dat je context gebruikt]
    },
  };
})(jQuery);
